var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseFilters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8989 7.05095C16.5085 6.6605 15.8754 6.66046 15.4849 7.05087L11.949 10.586L8.41397 7.05099C8.0235 6.66053 7.39043 6.66053 6.99997 7.05099C6.6095 7.44146 6.6095 8.07453 6.99997 8.46499L10.535 12L6.99997 15.535C6.6095 15.9255 6.6095 16.5585 6.99997 16.949C7.39043 17.3395 8.0235 17.3395 8.41397 16.949L11.949 13.414L15.4849 16.9491C15.8754 17.3395 16.5085 17.3395 16.8989 16.949C17.2894 16.5585 17.2894 15.9254 16.8989 15.535L13.364 12L16.8989 8.46504C17.2894 8.07455 17.2894 7.44144 16.8989 7.05095Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilters);
export default __webpack_public_path__ + "static/media/close-filters.b089ef362f9af1aa150412a28c5224a5.svg";
export { ForwardRef as ReactComponent };